import React from 'react';
import {
  Button, DialogActions, DialogContent, DialogTitle, Typography,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import AppDialog from '../../../shared/components/AppDialog';

export default function Scope3AfDeleteConfirmDialog({
  open,
  fileName,
  onClose,
  onConfirm,
}) {
  const { t } = useTranslation();

  return (
    <AppDialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>{t('dataInput.scope3Af.deleteConfirmTitle')}</DialogTitle>
      <DialogContent>
        <Typography variant="body2" color="text.secondary">
          {t('dataInput.scope3Af.deleteConfirmMessage', {
            file: fileName || t('dataInput.scope3Af.thisFile'),
          })}
        </Typography>
      </DialogContent>
      <DialogActions sx={{ px: { xs: 2, sm: 3 }, py: 1.5 }}>
        <Button onClick={onClose}>{t('common.cancel')}</Button>
        <Button color="error" variant="contained" onClick={onConfirm}>
          {t('dataInput.scope3Af.deleteConfirmAction')}
        </Button>
      </DialogActions>
    </AppDialog>
  );
}
